{
    "welcome": "Willkommen",
    "getStarted": "Loslegen"
}
